import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import { Row, Col, Card, Table, Button, Badge, Modal } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";
import Preloader from "../../Components/Preloader";
import { deleteCameraData, getCameraList, updateCameraStatusData, getCameraListById, playCameraData, updateCameraData } from "../../redux/actions/CameraActions";
import VideoModal from "../../Components/VideoModal";
import Status from "../../enums/Status";



const Dashboard = () => {
  const { t } = useTranslation();
  const tableRef = useRef();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    AuthReducer: { auth, errors },
    cameraReducer: {
      cameraLists,
      cameraPermissions,
      loadingCamera,
      errorsCamera,
      cameraCount,
      changedCameraStatus,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort] = useState('desc');
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  // useEffect(() => {
  //   dispatch(getCityList(auth?.accessToken, paginate, page, search, sort));
  //   console.log('cityLists',cityLists);
  // }, [auth, paginate, page, search, sort]);

  const fetchCameraList = useCallback(() => {
    if (auth?.accessToken) {
      dispatch(getCameraList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchCameraList, 500, [auth, paginate, page, search, sort]);

  useEffect(() => {
    if (errors) {
      if (errors?.status === 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate])

  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? cameraCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteCameraData(auth?.accessToken, id))
        }
      });
  };

  const handleStatusChangeRequest = (item, newStatus) => {
    swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${newStatus}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedPayload = {
           nvrId: item?.nvr?.id,
          cameraId: item?.cameraId,
          cameraName: item?.cameraName,
          cameraChannel:Number(item?.cameraChannel),
          status: newStatus,
        }
        
        if (!updatedPayload.nvrId) {
          swal.fire({
            title: "Error",
            text: "Camera NVR information is missing",
            icon: "error",
          });
          return;
        }
        
        if (isNaN(updatedPayload.cameraChannel)) {
          swal.fire({
            title: "Error",
            text: "Invalid camera channel",
            icon: "error",
          });
          return;
        }
        dispatch(updateCameraData(auth?.accessToken, updatedPayload, item?.id));
      }
    });
  };

  const handlePlayVideo = (camera) => {
    setSelectedCamera(camera);
    setShowVideoModal(true);
    // Optionally dispatch action to get detailed camera data
    if (auth?.accessToken) {
      dispatch(playCameraData(auth?.accessToken, camera.id));
    }
  };

  const handleCloseVideoModal = () => {
    setShowVideoModal(false);
    setSelectedCamera(null);
  };

  const handleImageClick = (externalId) => {
    const imageUrl = `https://phedrserver.consoletrack.com/upload/cameras/${externalId}/camera_${externalId}.jpg`;
    setSelectedImageUrl(imageUrl);
    setImageLoading(true);
    setImageError(false);
    setShowImageModal(true);
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setSelectedImageUrl(null);
    setImageLoading(false);
    setImageError(false);
  };

  const handleImageLoad = () => {
    setImageLoading(false);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
  };

  const getImageUrl = (externalId) => {
    return `https://phedrserver.consoletrack.com/upload/cameras/${externalId}/camera_${externalId}.jpg`;
  };


  useEffect(() => {
    if (changedCameraStatus?.message) {
      swal.fire({
        show: true,
        // title: "Deleted!",
        text: changedCameraStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      dispatch(getCameraList(auth?.accessToken, paginate, page, search, sort));
    }
    else if (changedCameraStatus.message) {
      swal.fire({
        show: true,
        title: "Great !",
        text: changedCameraStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      dispatch(getCameraList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [changedCameraStatus, auth?.accessToken, dispatch, paginate, page, search, sort])


  useEffect(() => {
    if (errorsCamera && Object.keys(errorsCamera).length > 0) {
      if (errorsCamera?.status === 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
      }
    }
  }, [errorsCamera, dispatch, errors?.data?.message, navigate]);


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Camera"), path: "/Camera", active: true },
        ]}
        title={t("Camera")}
      />

      <Row>
        <Col>
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white border-0 pb-0">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center">
                    <i className="mdi mdi-camera text-primary" style={{ fontSize: '1.5rem' }}></i>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h4 className="mb-0">Camera Management</h4>
                  <p className="text-muted mb-0">Monitor and manage all surveillance cameras</p>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="pt-3">
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    {(cameraPermissions?.filter) && (
                      <>
                        <div className="d-flex align-items-center position-relative">
                          <i className="mdi mdi-magnify position-absolute" style={{ left: '15px', zIndex: 2, color: '#6c757d' }}></i>
                          <input
                            type="search"
                            placeholder="Search cameras..."
                            className="form-control ps-5 border-0 bg-light"
                            autoComplete="off"
                            value={search}
                            onChange={handleSearchChange}
                            style={{ borderRadius: '25px' }}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                        {(cameraPermissions?.add) && (
                          <>
                            <Link to="/Add-Camera">
                              <Button
                                variant="success"
                                className="me-2"
                                style={{ borderRadius: '25px', fontWeight: '500' }}
                              >
                                <i className="mdi mdi-plus me-1"></i>Add Camera
                              </Button>
                            </Link>
                          </>
                        )}
                        {(cameraPermissions?.print) && (
                          <>
                            <Button
                              variant="outline-secondary"
                              className="me-2"
                              style={{ borderRadius: '25px', fontWeight: '500' }}
                            >
                              <i className="mdi mdi-printer me-1"></i>Print
                            </Button>
                          </>
                        )}
                        {(cameraPermissions?.excel) && (
                          <>
                            <Button
                              variant="outline-info"
                              style={{ borderRadius: '25px', fontWeight: '500' }}
                            >
                              <i className="mdi mdi-file-excel me-1"></i>Export
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="table-responsive" style={{ overflowY: 'auto', maxHeight: '500px', borderRadius: '10px', border: "1px solid #e9ecef" }}>
                <Table ref={tableRef} className="mb-0 table-hover"
                  responsive
                  id="table-to-print"
                  style={{ width: "100%", tableLayout: "auto" }}>
                  <thead style={{ position: "sticky", top: 0, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", zIndex: 1 }}>
                    <tr>
                      <th className="text-white fw-semibold border-0">#</th>
                      <th className="text-white fw-semibold border-0">Image</th>
                      <th className="text-white fw-semibold border-0">Camera Name</th>
                      <th className="text-white fw-semibold border-0">Channel</th>
                      <th className="text-white fw-semibold border-0">NVR Name</th>
                      <th className="text-white fw-semibold border-0">NVR IP</th>
                      <th className="text-white fw-semibold border-0">NVR Port</th>
                      <th className="text-white fw-semibold border-0">Status</th>
                      <th className="text-white fw-semibold border-0">Registered At</th>
                      <th className="text-white fw-semibold border-0">Last Connected</th>
                      <th className="text-white fw-semibold border-0">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cameraLists.length === 0 ? (
                      <tr>
                        <td colSpan="11">No data found</td>
                      </tr>
                    ) : (<>
                      {cameraLists?.map?.((item, index) => {
                        return (
                          <tr key={item.id}>
                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                            <td>
                              {item?.id ? (
                                <img
                                  src={getImageUrl(item.id)}
                                  alt={item?.cameraName || 'Camera'}
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'cover',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    border: '2px solid #e9ecef'
                                  }}
                                  onClick={() => handleImageClick(item.id)}
                                  onError={(e) => {
                                    e.target.src = 'https://via.placeholder.com/60x60?text=No+Image';
                                  }}
                                />
                              ) : (
                                <div style={{
                                  width: '60px',
                                  height: '60px',
                                  backgroundColor: '#f0f0f0',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#999'
                                }}>
                                  <i className="mdi mdi-image-off" style={{ fontSize: '24px' }}></i>
                                </div>
                              )}
                            </td>
                            <td>{item?.cameraName}</td>
                            <td>{item?.cameraChannel}</td>
                            <td>{item?.nvr?.nvrName}</td>
                            <td>{item?.nvr?.nvrIp}</td>
                            <td>{item?.nvr?.nvrPort}</td>
                            <td>{item?.status === Status.ACTIVE ? <Badge className={"bg-success"}>{item?.status}</Badge> : <><Badge className={"bg-danger"}>{item?.status}</Badge></>}</td>
                            <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                            <td>{item?.lastConnectedAt ? getDisplayDateTimeFormat(item?.lastConnectedAt) : <span className="text-muted">Never</span>}</td>
                            <td>
                              {(cameraPermissions?.edit) && (
                                <>
                                  {item?.status === Status.ACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-success" onClick={() => handleStatusChangeRequest(item, Status.INACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye"></i>
                                      </Link>
                                    </>
                                  )}
                                  {item?.status === Status.INACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-warning" onClick={() => handleStatusChangeRequest(item, Status.ACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye-off"></i>
                                      </Link>
                                    </>
                                  )}

                                  <Link to={`/Update-Camera/${item?.id}`} className="action-icon text-info me-2">
                                    <i className="mdi mdi-square-edit-outline"></i>
                                  </Link>
                                  <Button
                                    variant="link"
                                    className="action-icon text-primary p-0 me-2"
                                    onClick={() => handlePlayVideo(item)}
                                    title="Play Video"
                                  >
                                    <i className="mdi mdi-play-circle" style={{ fontSize: '1.2rem' }}></i>
                                  </Button>
                                </>
                              )}

                              {(cameraPermissions?.delete) && (
                                <>
                                  <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)} >
                                    {" "}
                                    <i className="mdi mdi-delete"></i>
                                  </Link>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}</>
                    )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(cameraCount / paginate)}</strong> </span>
                <RoundedPagination
                  currentPage={page}
                  totalPages={Math.ceil(cameraCount / paginate)}
                  onPageChange={(pageNumber) => setPage(pageNumber)}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Video Modal */}
      <VideoModal
        show={showVideoModal}
        onHide={handleCloseVideoModal}
        cameraData={selectedCamera}
        title={selectedCamera?.name || "Live Camera Feed"}
      />

      {/* Image Modal */}
      <style>
        {`
          .image-modal .modal-content {
            border: none !important;
            box-shadow: none !important;
            background: transparent !important;
            padding: 0 !important;
          }
          .image-modal .modal-dialog {
            max-width: none !important;
            margin: 0 auto !important;
          }
        `}
      </style>
      <Modal
        show={showImageModal}
        onHide={handleCloseImageModal}
        size="xl"
        centered
        className="image-modal"
        backdrop="static"
      >
        <Modal.Body className="p-0 border-0">
          <div
            className="position-relative"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '400px',
              backgroundColor: 'transparent'
            }}
          >
            {/* Close Button Overlay */}
            <button
              onClick={handleCloseImageModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: 1000,
                background: 'rgba(0, 0, 0, 0.6)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                color: 'white',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                transition: 'background 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(0, 0, 0, 0.8)'}
              onMouseLeave={(e) => e.target.style.background = 'rgba(0, 0, 0, 0.6)'}
            >
              <i className="mdi mdi-close"></i>
            </button>

            {imageLoading && (
              <div
                className="position-absolute"
                style={{
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1
                }}
              >
                <div className="spinner-border text-white" role="status" style={{ width: '3rem', height: '3rem' }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            {imageError ? (
              <div className="p-5 text-center text-white">
                <i className="mdi mdi-image-off" style={{ fontSize: '64px', opacity: 0.5 }}></i>
                <p className="mt-3">Image not found</p>
              </div>
            ) : selectedImageUrl && (
              <img
                src={selectedImageUrl}
                alt="Camera"
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{
                  maxWidth: '90vw',
                  maxHeight: '90vh',
                  height: 'auto',
                  objectFit: 'contain',
                  transition: 'transform 0.3s ease, opacity 0.3s ease',
                  cursor: 'zoom-in',
                  opacity: imageLoading ? 0 : 1
                }}
                onClick={(e) => {
                  if (e.target.style.transform === 'scale(1.5)') {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.cursor = 'zoom-in';
                  } else {
                    e.target.style.transform = 'scale(1.5)';
                    e.target.style.cursor = 'zoom-out';
                  }
                }}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>

      {loadingCamera && (<Preloader />)}
    </>
  );
};

export default Dashboard;